import {styled} from "@mui/system";
import {Fab} from "@mui/material";

export const FormFab = styled(Fab)({
  transform: 'scale(0.75)'
});

